import type { AdminSubmission, DateNightAnswers, InvitationResponse } from "../types/dateNight";

async function decode<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const body: unknown = await response.json().catch(() => ({ error: "Er ging iets mis." }));
    const message = typeof body === "object" && body !== null && "error" in body && typeof body.error === "string" ? body.error : "Er ging iets mis.";
    throw new Error(message);
  }
  return response.json<T>();
}

export const getInvitation = (token: string) => fetch(`/api/date-night/invite/${encodeURIComponent(token)}`).then(decode<InvitationResponse>);

export const submitInvitation = (token: string, answers: DateNightAnswers) =>
  fetch(`/api/date-night/invite/${encodeURIComponent(token)}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(answers),
  }).then(decode<{ success: true; updated: boolean }>)
;

export const getLatestSubmission = () => fetch("/api/date-night/admin/latest").then(decode<AdminSubmission | null>);
